import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const h3 = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 14,
	fontWeight: 700,
	textTransform: "uppercase",
	marginBottom: 12,
	marginTop: 0,
	color: "#007a8d",
};
const p = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 13,
	color: "#444",
	margin: 0,
};

// Template92: Metro NY (guia-ny Subway). Contenido desde page.
const Template92 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const headerText =
		page?.texts?.[0]?.content ?? "Consejos para usar el Metro en Nueva York";
	const introText = page?.texts?.[1]?.content;
	const appsTitle = page?.texts?.[2]?.content ?? "📱 Apps que te salvan";
	const appsListHtml = page?.texts?.[3]?.content;
	const metrocardNote = page?.texts?.[4]?.content;
	const tipsTitle = page?.texts?.[5]?.content ?? "🚇 Consejos rápidos";
	const tipsListHtml = page?.texts?.[6]?.content;
	const importantBox = page?.texts?.[7]?.content;
	const payTitle = page?.texts?.[8]?.content ?? "💳 Cómo pagar con OMNY";
	const payListHtml = page?.texts?.[9]?.content;

	const subwaySticker = getImageSrc("metro-main") || getImageSrc("subway");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				backgroundColor: "#f7f7f7",
				fontFamily: fontFamily || '"Poppins", sans-serif',
				"& *": {
					fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1053,
				}}
			>
				{headerText}
			</div>
			{introText && (
				<div data-block-id="text-1" style={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<p style={p}>{introText}</p>
				</div>
			)}
			{/* Caja Apps */}
			<div
				data-block-id="text-2"
				style={{
					position: "relative",
				}}
			>
				<div
					style={{
						backgroundColor: "#e0f7fa",
						border: "2px solid #59c3d8",
						borderRadius: 16,
						padding: "16px",
						margin: "0 16px 16px 16px",
						position: "relative",
						width: isSmallScreen ? "60%" : "60%",
					}}
				>
					<h3 style={h3}>{appsTitle}</h3>
					{appsListHtml ? (
						<div
							style={{ paddingLeft: 0, margin: 0, fontSize: 13 }}
							dangerouslySetInnerHTML={{ __html: appsListHtml }}
						/>
					) : (
						<ul style={{ paddingLeft: 18, margin: 0, fontSize: 13 }}>
							<li>
								<strong>NY Subway MTA:</strong> Horarios en tiempo real y
								alertas.
							</li>
							<li>
								<strong>Citymapper:</strong> Planificación de rutas.
							</li>
							<li>
								<strong>Google Maps:</strong> Indicaciones del transporte
								público.
							</li>
						</ul>
					)}
				</div>
				{subwaySticker && (
					<img
						src={subwaySticker}
						alt="subway"
						style={{
							width: 110,
							position: "absolute",
							bottom: isSmallScreen ? 30 : 20,
							right: isSmallScreen ? -10 : 12,
						}}
					/>
				)}
				{metrocardNote && (
					<div
						style={{
							position: "absolute",
							bottom: isSmallScreen ? 100 : 100,
							right: isSmallScreen ? 20 : 30,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 0px 16px",
							padding: "10px 12px",
							fontSize: 11,
							fontFamily: '"Poppins", sans-serif',
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 112,
						}}
					>
						<div dangerouslySetInnerHTML={{ __html: metrocardNote }} />
					</div>
				)}
			</div>
			{/* Consejos rápidos */}
			<div
				data-block-id="text-3"
				style={{
					padding: "0 16px",
					fontSize: 13,
					color: "#444",
				}}
			>
				<h3 style={h3}>{tipsTitle}</h3>
				{tipsListHtml ? (
					<div
						style={{ paddingLeft: 0 }}
						dangerouslySetInnerHTML={{ __html: tipsListHtml }}
					/>
				) : (
					<ul style={{ paddingLeft: 18 }}>
						<li>
							Varias líneas comparten vías: fíjate bien en el número o la letra
							del tren antes de subir.
						</li>
						<li>
							Hay trenes locales y express: los locales paran en todas las
							estaciones, los express solo en las principales.
						</li>
						<li>
							Atento a Uptown (norte) o Downtown (sur) según la dirección de tu
							viaje.
						</li>
						<li>Usa OMNY o MetroCard para pagar.</li>
					</ul>
				)}
			</div>
			{importantBox && (
				<div data-block-id="text-4" style={{ padding: "0 16px" }}>
					<div
						style={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: 12,
							padding: "10px 12px",
							marginTop: 8,
							fontSize: 12,
							fontFamily: '"Poppins", sans-serif',
							color: "#444",
						}}
					>
						<div dangerouslySetInnerHTML={{ __html: importantBox }} />
					</div>
				</div>
			)}
			{/* Cómo pagar OMNY */}
			<div
				data-block-id="text-5"
				style={{
					padding: "12px 16px",
					fontSize: 13,
					color: "#444",
					marginTop: 2,
					paddingBottom: 0,
				}}
			>
				<h3 style={h3}>{payTitle}</h3>
				{payListHtml ? (
					<div
						style={{ paddingLeft: 0 }}
						dangerouslySetInnerHTML={{ __html: payListHtml }}
					/>
				) : (
					<ul style={{ paddingLeft: 18 }}>
						<li>
							Pasa tu tarjeta contactless, móvil o smartwatch directamente en el
							torno.
						</li>
						<li>No hace falta comprar billetes ni recargar nada.</li>
						<li>
							Después de 12 viajes en 7 días, el resto de trayectos son gratis
							automáticamente.
						</li>
					</ul>
				)}
			</div>
		</Box>
	);
};

export default Template92;
